<template>
  <div>
    <!-- Swiper -->
    <div class="swiper-container out_swiper" ref="mySwiper">
      <!-- 第一屏 -->

      <div class="section section1">
        <swiper class="swiper-container one_swiper">
          <swiper-slide>
            <img src="../assets/img/home/banner.jpg" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/home/tu_1.2.png" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/home/tkzz.jpg" alt="" />
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/home/xiaomishu.jpg" alt="" />
          </swiper-slide>
          <!-- <swiper-slide>
                <a href="https://dmbj.youxiet.com/">
                  <img src="../assets/img/home/tu_1.3.png" alt="">
                </a>

              </swiper-slide> -->
          <!--<swiper-slide>
                <img src="../assets/img/home/tu_1.3.gif" alt="">
              </swiper-slide>-->
        </swiper>
        <div class="swiper-pagination"></div>
      </div>
      <!-- 第一屏end -->

      <!-- 第二屏 -->
      <div class="section section2">
        <div class="sec-wrap">
          <div class="fp-content">
            <div class="item">
              <h4>企业文化</h4>
              <h4 class="en">CULTURE</h4>
              <div class="color_div"></div>
              <p>挑战自我，全力以赴</p>
              <span>Challenge yourself and do your best</span>
            </div>
            <div class="item">
              <h4>愿景</h4>
              <h4 class="en">VISION</h4>
              <div class="color_div"></div>
              <p>成为国内领先的泛娱乐数字内容提供商与数字营销服务商</p>
            </div>
            <div class="item">
              <h4>使命</h4>
              <h4 class="en">MISSION</h4>
              <div class="color_div"></div>
              <p>走进用户，用心打造面向未来的互联网娱乐平台</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 第二屏end -->
      <!-- 第三屏 -->
      <div class="section section3">
        <div class="sec-wrap">
          <div class="fp-content">
            <div class="fp-hd">
              <h4>企业价值观</h4>
              <p>ENTERPRISE VALUES</p>
            </div>
            <div class="content-wrap">
              <div class="icon-wrap ct1">
                <div class="item">
                  <div class="img-item">
                    <img src="../assets/img/home/p3_1.png" alt="" />
                  </div>
                  <h6>向上</h6>
                  <p>积极向上<br />拼搏向前</p>
                  <p></p>
                </div>
                <div class="item">
                  <div class="img-item">
                    <img src="../assets/img/home/p3_2.png" alt="" />
                  </div>
                  <h6>创新</h6>
                  <p>激活人人创新天赋，以创造力构建公司发展基石</p>
                  <p></p>
                </div>
                <div class="item">
                  <div class="img-item">
                    <img src="../assets/img/home/p3_3.png" alt="" />
                  </div>
                  <h6>尊重</h6>
                  <p>拥抱八方<br />众志成城</p>
                </div>
                <div class="item">
                  <div class="img-item">
                    <img src="../assets/img/home/p3_4.png" alt="" />
                  </div>
                  <h6>学习</h6>
                  <p>锻造学习热情与毅力，应对未来挑战</p>
                </div>
                <div class="item">
                  <div class="img-item">
                    <img src="../assets/img/home/p3_5.png" alt="" />
                  </div>
                  <h6>分享</h6>
                  <p>用智慧点亮智慧<br />打造思想矩阵</p>
                  <p></p>
                </div>
                <div class="item">
                  <div class="img-item">
                    <img src="../assets/img/home/p3_6.png" alt="" />
                  </div>
                  <h6>协作</h6>
                  <p>坦诚助人<br />感恩受助</p>
                </div>
                <!-- <div class="item">
                      <div class="img-item">
                        <img src="../assets/img/home/jz_gt.png" alt="">
                      </div>
                      <h6>沟通</h6>
                      <p>精准、简要、清晰，保障前进步伐</p>
                    </div> -->
                <!-- <div class="item">
                      <div class="img-item">
                        <img src="../assets/img/home/jz_cy.png" alt="">
                      </div>
                      <h6>创业</h6>
                      <p>不畏困难，不断完善，不断突破</p>
                    </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三屏end -->
      <!-- 第四屏 -->
      <div class="section section4" style="height: 720px">
        <div class="sec-wrap">
          <div class="fp-content">
            <div class="left-wrap">
              <div class="img-wrap">
                <img src="../assets/img/home/24logo.png" alt="" />
              </div>

              <div class="content">
                <h6>
                  <h6 class="text_or">2019年4月成立</h6>
                  巨芯互娱游戏机构，8月份成功晋升为抖音小游戏活跃机构top1
                </h6>
              </div>
              <div class="desc">
                <div class="img-wrap">
                  <img src="../assets/img/home/tu_3.1.1.png" alt="" />
                </div>
                <div class="text-wrap">
                  <p>
                    在以抖音为主的多个内容平台积累了丰富的达人和网红孵化经验;
                  </p>
                  <p>帮助达人在初级阶段参与流量变现;</p>
                  <p>实现流量收益双扶持计划，并拓展文教、二次元等领域;</p>
                  <p>累积服务百万mau以上小游戏超15款</p>
                </div>
              </div>
            </div>
            <div class="img-five">
              <img src="../assets/img/home/p4_2.png" alt="" />
              <img src="../assets/img/home/p4_3.png" alt="" />
              <img src="../assets/img/home/p4_4.png" alt="" />
              <img src="../assets/img/home/p4_5.png" alt="" />
              <img src="../assets/img/home/p4_6.png" alt="" />
            </div>
          </div>
          <div class="wrap">
            <div class="left">
              <div class="img-wrap">
                <img src="../assets/img/home/p4_1.png" alt="" />
              </div>
              <p>
                2021年成功跻身抖音游戏榜top2，先后服务过腾讯、网易、朝夕光年、吉比特等知名企业。并在2月份发行抖音小游戏《我这一刀下去》在抖音取得话题破亿成绩。未来机构坚持以连同协作、共创价值为服务导向。以释放创意、传播快乐为内容宗旨。继续为合作伙伴和客户们实现流量赋能、携手共赢！
              </p>
            </div>
          </div>
          <div class="fp-ft">
            <div class="ft-wrap">
              <div class="img-wrap">
                <img src="../assets/img/home/p4_7.png" alt="" />
              </div>
              <div class="count-wrap">
                <div class="item">
                  <div>
                    <h2 id="num1">1.5</h2>
                    <span>亿+</span>
                  </div>
                  <p>全网粉丝人数</p>
                  <span>Number of fans in the whole</span>
                  <span class="color_line"></span>
                </div>
                <div class="item">
                  <div>
                    <h2 id="num2">6000</h2>
                    <span>+</span>
                  </div>
                  <p>达人资源</p>
                  <span>Talent resources</span>
                  <span class="color_line"></span>
                </div>
                <div class="item">
                  <div>
                    <h2 id="num3">600</h2>
                    <span>+</span>
                  </div>
                  <p>合作游戏</p>
                  <span>Cooperative ganme</span>
                  <span class="color_line"></span>
                </div>
                <div class="item">
                  <div>
                    <h2 id="num4">5000</h2>
                    <span>万+</span>
                  </div>
                  <p>日播放</p>
                  <span>Day play</span>
                  <span class="color_line"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第四屏end -->

      <!-- 第五屏 -->
      <div class="section section5">
        <div class="sec-wrap backgroundImg" style="position: relative">
          <!-- 添加背景图作为实际图片元素，确保容器高度自适应图片 -->
          <img src="../assets/img/home/p5bg.png" class="bg-image" alt="" />
          <div
            class="fp-content"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
          >
            <div class="left-wrap">
              
              <div class="desc">
                <h4>
                  大吕旗下品牌SOFTFIRE拥有
                  <img src="../assets/img/home/p5text.png" alt="" />官方正版授权
                </h4>
                <p>
                  SOFTFIRE契合篮球运动精神，重磅推出NBA联名款产品线，SOFTFIRE&NBA联名款童装旨在通过优秀的产品质量，时尚潮流设计，创造每个青少年喜爱的NBA联名款童装。
                </p>
              </div>
            </div>
            <div class="count-wrap">
              <div class="item">
                <p>
                  SOFTFIRE&NBA联名款童装<br>专为16岁以下青少年打造休闲运动风童装</br>
                </p>
                <p>
                  目前在各大主流平台：抖音、天猫、得物、快手、小红书、京东、拼多多等设有线上店铺提供购买渠道，未来大吕将搭建有机联动矩阵，致力将SOFTFIRE打造成高知名度新锐美式潮流运动童装。
                </p>
              </div>
            </div>
            <div class="img-wrap logo-container">
                <img src="../assets/img/home/p5qdlogo.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 第五屏end -->
      <!-- 第六屏 -->
      <div class="section section6" style="height: 980px">
        <div class="sec-wrap">
          <div class="fp-content">
            <div class="left-wrap">
              <div class="img-wrap">
                <img src="../assets/img/home/p6_1.png" alt="" />
                <div class="title-wrap">
                  <h4>2.5<span>亿+</span></h4>
                  <p>日覆盖移动互联网用户媒体</p>
                  <span>Daily coverage of mobile Internet user media</span>
                </div>
              </div>
              <div class="img2-wrap">
                <img src="../assets/img/home/p6_2.png" alt="" />
                <div class="title-wrap t2">
                  <h4>5<span>亿+</span></h4>
                  <p>日展示广告资源</p>
                  <span>Daily display advertising resources</span>
                </div>
              </div>
            </div>
            <div class="right-wrap">
              <div class="img-wrap">
                <img src="../assets/img/home/fylogo.png" alt="" />
              </div>
              <div class="desc-wrap">
                <div class="content">
                  <p>
                    厦门火吖科技有限公司(简称：火吖科技)，专注于移动互联网数据整合营销解决方案，全面布局移动互联网广告营销生态企业。
                  </p>
                  <p>
                    火吖科技总部坐落于美丽的福建省厦门市，并在泉州设有分公司，凭借自主研发的云控精准广告分发平台以及先发的行业优势，集聚了国内大量的wap站、APP应用等优质长尾流量，构建了强大的广告投放渠道，成为知名互联网企业的核心流量供应商，并为字节跳动长线提供精准广告投放服务，是中国优质的互联网广告投放服务提供商，一直以来火吖科技秉承着“客户至上，合作共赢，创造极致价值”为使命，以“诚信、专注、共赢、创新”为价值观，未来公司不仅于线上发力，也将与线下全面结合，并借助资本市场的力量实现持续扩张，在专业化与多元化并行的同时，实现全新突破。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 第六屏end -->
      <!-- 第七屏 -->
      <div class="section section7" style="height: 700px">
        <div class="sec-wrap">
          <div class="right-wrap">
            <div class="desc-wrap">
              <div class="img-wrap">
                <img src="../assets/img/home/jxlogo.png" alt="" />
              </div>

              <p>
                巨芯科技成立于2018年5月3日，是一家以广告投放业务为主的公司，公司承接广告咨询服务，设计、制作、代理发布国内各类广告等为广大客户提供高效、精准的投放服务。
              </p>
              <p>
                公司有海量资源覆盖全方位用户，助力广告主抢占市场先机，以智能营销、组合玩法、数据驱动新理念，撬动营销新力量，让营销变得更简单。
              </p>
              <p>
                公司为广告主提供全面、智能的广告投放管理，充分提高广告投放效率，基于大数据智能算法推荐，通过多种定向方式，将广告精准分发给目标人群，针对行业特征及细分业务场景，深度引流。公司与地产、家居、通讯、金融、医疗、游戏等多个行业的客户公司保持合作关系，更是字节跳动长期的核心合作伙伴。
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 第七屏end -->
    </div>
  </div>
</template>

<script>
import AppFooter from "../components/Footer.vue";
import $ from "jquery";
import Swiper from "swiper";
import * as homeApi from "api/index";

// var count = [];
// var datas = [
//   {start: 0, end: 1.5, decimals: 1},
//   {start: 500, end: 6000, decimals: 0},
//   {start: 0, end: 600, decimals: 0},
//   {start: 400, end: 5000, decimals: 0}
// ];

// for(var i=0; i<datas.length; i++){
//   if (i < 4) {
//       count.push(new CountUp('num'+ (i + 1), datas[i].start, datas[i].end, datas[i].decimals, 10, options));
//     } else {
//       count.push(new CountUp('num'+ (i + 1), datas[i].start, datas[i].end, datas[i].decimals, 10, options));
//     }
//   }

export default {
  name: "home",
  components: {
    AppFooter,
  },
  data() {
    return {
      pages: "1",
      showTop: false,
    };
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {},
  mounted() {
    new Swiper(".one_swiper", {
      autoplay: 5000,
      autoplayDisableOnInteraction: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true,
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/index";
$plus-width: 414px;

img {
  user-select: none;
  -webkit-user-drag: none;
}

#fullPage {
  overflow: hidden;
}

.section {
  height: auto;
  .sec-wrap {
    width: 100%;
    height: 100%;
  }
}
img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.swiper-slide {
  margin-top: 4rem;
  height: 667px;
  img {
    object-fit: cover;
  }
  @media screen and(min-width:$plus-width) {
    height: 775px;
  }
}

@keyframes slowScale {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.section1 {
  img {
    height: 100%;
  }
  .sec-wrap {
    background: url("../assets/img/home/tu_1.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.section2 {
  .sec-wrap {
    display: flex;
    justify-content: center;
    background: url("../assets/img/home/p2_bg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .animation1 {
      bottom: -1400px;
      opacity: 1;
    }
    .fp-content {
      margin: 2rem auto;
      .item {
        background: url("../assets/img/home/p2_1.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 2.5rem 1rem;
        margin: 1rem;
        h4 {
          color: #fff;
          letter-spacing: 1px;
          margin-bottom: 0.5rem;
        }
        p,
        span {
          color: #fff;
          opacity: 0.85;
          width: 70%;
          font-size: 0.8rem;
        }
        &:nth-of-type(2) {
          background: url("../assets/img/home/p2_2.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
        &:nth-of-type(3) {
          background: url("../assets/img/home/p2_3.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .color_div {
        width: 0.5rem;
        height: 0.5rem;
        background-color: #fff;
        margin: 0.5rem 0;
      }
      .en {
        color: #fff;
        opacity: 0.3;
      }
    }
  }
}

.section3 {
  h4,
  p {
    text-align: center;
  }
  .fp-hd {
    margin-bottom: 1rem;
    h4,
    p {
      color: #fff;
      letter-spacing: 1px;
    }
    p {
      opacity: 0.5;
    }
  }
  .sec-wrap {
    display: flex;
    justify-content: center;
    background: url("../assets/img/home/p3bg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .fp-content {
    margin: 2rem 1rem 3rem;
    padding: 2rem;
    background: url("../assets/img/home/tu_33.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .icon-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .item {
        width: 50%;
        margin-top: 0.5rem;
        .img-item {
          width: 50%;
          margin: 0 auto;
        }
        h6 {
          line-height: 1.5rem;
          margin-top: 0.5rem;
          font-size: 0.8rem;
        }
        h6,
        p {
          text-align: center;
          line-height: 1.2rem;
          color: #fff;
        }
        p {
          opacity: 0.8;
          width: 75%;
          margin: 0 auto;
          line-height: 1rem;
        }
      }
    }
  }
}
.section4 {
  .sec-wrap {
    height: 50rem;
    display: flex;
    justify-content: center;
    background: url("../assets/img/home/p4bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
  }
  .fp-content {
    padding: 2rem 1rem 3rem;
    .content {
      h6 {
        display: inline-block;
        font-size: 0.8rem;
        color: #fff;
        letter-spacing: 1px;
      }
      .text_or {
        color: #ffca45;
        font-size: 1.5rem;
      }
    }
    .desc {
      display: flex;
      padding-top: 1rem;
      p {
        color: #fff;
      }
      .img-wrap {
        padding: 0 1rem;
        img {
          width: 1rem;
          height: 1rem;
        }
      }
    }
  }
  .left-wrap {
    > .img-wrap {
      width: 40%;
      margin: 0 auto;
    }
  }
  .img-five {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    img {
      padding: 0 0.2rem;
      width: 19%;
    }
  }
  .fp-ft {
    position: absolute;
    right: 0px;
    bottom: 0;
    .ft-wrap {
      position: relative;
      .img-wrap {
        width: 100%;
        img {
          width: 100%;
          object-fit: contain;
        }
      }
      .count-wrap {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 14%;
        left: 0;
        width: 100%;
        flex-wrap: wrap;
        .item {
          width: 45%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-top: 0.6rem;

          > div {
            color: #fff;
            letter-spacing: 1px;
            text-align: center;
            margin-bottom: 0.3rem;
            h2 {
              display: inline;
              font-size: 1.8rem;
            }
            span {
              margin: auto;
            }
          }

          & > p,
          & > span {
            line-height: 1rem;
            color: #fff;
            text-align: center;
            display: block;
            font-size: 0.5rem;
          }
          .color_line {
            display: block;
            height: 1px;
            width: 50%;
            background-color: #ffca45;
            margin: 0.2rem auto 0.8rem;
          }
        }
      }
    }
  }
  .wrap {
    position: absolute;
    left: 0px;
    bottom: 27%;
    width: 95%;
    z-index: 66;
    opacity: 1;
    @media screen and (min-width: $plus-width) {
      bottom: 30%;
    }
    .left {
      position: relative;
      .img-wrap {
        height: 160px;
        position: relative;
        overflow: hidden;
        @media screen and (min-width: $plus-width) {
          height: 130px;
        }
      }
      p {
        position: absolute;
        width: 92%;
        right: 1rem;
        top: 1rem;
      }
    }
  }
}
.section5 {
  height: auto; /* 高度自适应图片 */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto; /* 水平居中 */
    .img-wrap {
        margin: 1rem auto;
        text-align: center;
        img {
          width: 60px;
          max-width: 120px; /* 设置最大宽度 */
          min-width: 60px; /* 设置最小宽度 */
          display: inline-block;
        }
        
        /* 响应式调整 */
        @media screen and (max-width: 768px) {
          img {
            width: 120px;
          }
        }
        
        @media screen and (max-width: 480px) {
          img {
            width: 60px;
          }
        }
      }
   
   /* 添加logo容器样式，包含两侧的蓝色横线 */
        .logo-container {
      width: 100% !important;
      position: relative;
      
      &::before, &::after {
        content: '';
        position: absolute;
        top: 50%;
        height: 2px;
        background-color: #3a97d4; /* 蓝色横线 */
        width: 30%;
      }
      
      &::before {
        right: 65%; 
      }
      
      &::after {
        left: 65%;
      }
      
      /* 响应式调整横线 */
      @media screen and (max-width: 768px) {
        // &::before, &::after {
        //   width: 35%;
        // }
        
        &::before {
          right: 70%; 
        }
        
        &::after {
          left: 70%;
        }
      }
      
      @media screen and (max-width: 480px) {
        // &::before, &::after {
        //   width: 30%;
        // }
        
        &::before {
          right: 65%; 
        }
        
        &::after {
          left: 65%;
        }
      }
  }
  
  .sec-wrap {
    margin-top: 4rem;
    /* 移除背景图，改用img元素 */
    // background: url("../assets/img/home/p5bg.png");
    // background-size: 100% auto;
    // background-position: center;
    // background-repeat: no-repeat;
  }
  .bg-image {
    width: 100%;
    height: auto;
    display: block;
    max-width: 100%; /* 确保图片不会溢出父容器 */
    object-fit: contain; /* 保持图片比例 */
  }
  .fp-content {
    .left-wrap {
      .desc {
        margin: 1rem;
        h4 {
          text-align: center;
          font-size: 0.8rem;
          margin: 0.5rem 0;
          color: #fff;
        }
        p {
          color: #fff;
        }
        img {
          width: 8%;
        }
      }
      
    }
  }
  .right-wrap {
    margin: 0.5rem 0;
  }
  .count-wrap {
    width: 100%;
    position: relative;
    left: 0;
    right: 0;
    bottom: 0px;
    opacity: 1;
    .item {
      margin: 1rem;
      .logo-wrap {
        width: 30%;
        margin: 0.5rem auto;
      }
      & > p {
        color: #fff;
        display: block;
        text-align: center;
      }
      &:nth-of-type(1) {
        background: url("../assets/img/home/tu_jb.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        & > p {
          color: #fff;
          padding: 0.5rem;
          letter-spacing: 0.5px;
        }
        @media screen and (min-width: 768px) {
          & > p {
            padding: 1rem;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}

.section6 {
  overflow: hidden;
  .sec-wrap {
    display: flex;
    justify-content: center;
    background: url("../assets/img/home/p6bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .fp-content {
    padding: 2rem 1rem 1rem;
  }
  .left-wrap {
    display: flex;
    position: relative;
    top: -50px;
    .img-wrap {
      position: relative;
      top: 10px;
      left: 0px;
      z-index: 66;
      // opacity: 0;
      width: 50%;
    }
    .t2 {
      left: 20px !important;
    }
    .title-wrap {
      position: absolute;
      bottom: 66px;
      left: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media screen and (min-height: 1000px) {
        bottom: 18rem;
      }
      h4,
      p,
      span {
        text-align: center;
        color: #fff;
        opacity: 0.75;
        font-size: 0.8rem;
        width: 90%;
      }
      h4 {
        font-size: 2rem;
        letter-spacing: 1px;
        margin-bottom: 15px;
        font-weight: 500;
        span {
          margin-left: 1px;
          font-weight: 700;
          letter-spacing: 4px;
        }
      }
      p {
        color: #fff;
        opacity: 0.75;
      }
      span {
        color: #fff;
        opacity: 0.75;
      }
    }
    .img2-wrap {
      position: absolute;
      left: 8.5rem;
      top: -20px;
      // opacity: 0;
      width: 50%;
      @media screen and (min-width: $plus-width) {
        left: 7.5rem;
      }
      @media screen and (min-height: 1000px) {
        left: 18rem;
        top: -5rem;
      }
      .title-wrap {
        position: absolute;
        bottom: 96px;
        left: 0;
        width: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        @media screen and (min-height: 1000px) {
          bottom: 18rem;
        }
      }
    }
  }
  .right-wrap {
    position: relative;
    top: -3rem;
    .img-wrap {
      width: 40%;
      margin: 1rem 0;
    }
    .desc-wrap {
      background: url("../assets/img/home/p6_3.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: 1rem;
      .content {
        p {
          color: #fff;
          padding-bottom: 0.5rem;
          line-height: 1.2rem;
          letter-spacing: 1px;
        }
      }
    }
  }
}

.section7 {
  .sec-wrap {
    margin-top: -15rem;
    display: flex;
    flex-direction: row-reverse;
    background: url("../assets/img/home/p7bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    > .right-wrap {
      position: relative;
      opacity: 1;
      right: 0px;
      background: url("../assets/img/home/tu_77.png");
      background-size: 100%;
      background-repeat: no-repeat;
      width: 91%;
      margin: 2rem auto;
      @media screen and (min-height: 1000px) {
        margin-top: 15rem;
      }
      .bg-wrap {
        position: absolute;
        bottom: 0;
        margin: auto;
        height: 100%;
      }
      .img-wrap {
        width: 50%;
        margin: 1rem auto 0.5rem;
      }
      p {
        padding: 0.5rem 1rem 0 1rem;
        line-height: 1.2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue